<template>
  <div v-if="insideNavbar" class="navbar--experience-availability">
    <LadAvailabilityHeader :experience="experience" />

    <LadAvailabilityContent
      :items="items"
      :experience="experience"
      :with-banner="!isExternalPlatform"
      :platform="exPlatform"
      :items-by-code="itemsByCode"
      @scrolled="handleScrolled"
      @reserve="handleReserve"
    />

    <LadAvailabilityFooter :is-scrolled-to-bottom="isScrolledToBottom" />
  </div>

  <el-dialog
    v-else
    :visible.sync="isAvailabilityModalOpen"
    :before-close="handleClose"
    class="dialog--experience-availability"
  >
    <template slot="title">
      <LadAvailabilityHeader :experience="experience" />
    </template>

    <LadAvailabilityContent
      :items="items"
      :experience="experience"
      :with-banner="!isExternalPlatform"
      :platform="exPlatform"
      :items-by-code="itemsByCode"
      @scrolled="handleScrolled"
      @reserve="handleReserve"
    />

    <template slot="footer">
      <LadAvailabilityFooter
        :is-scrolled-to-bottom="isScrolledToBottom"
        :inside-navbar="insideNavbar"
      />
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadAvailabilityModal',
  components: {
    LadAvailabilityHeader: () =>
      import(
        /* webpackChunkName: "lad-ava-header" */ '@/components/frontends/Availability/components/header'
      ),
    LadAvailabilityContent: () =>
      import(
        /* webpackChunkName: "lad-ava-content" */ '@/components/frontends/Availability/index'
      ),
    LadAvailabilityFooter: () =>
      import(
        /* webpackChunkName: "lad-ava-footer" */ '@/components/frontends/Availability/components/footer'
      ),
  },
  props: {
    experience: { type: Object, required: true },
    insideNavbar: { type: Boolean, default: false },
  },
  data() {
    return {
      isScrolledToBottom: false, // muestra/oculta efecto degradado de listado de fechas disponibles
    }
  },
  computed: {
    ...mapState('experience', {
      exPlatform: (state) => state.platform,
      isExternalPlatform: (state) => !state.experience.is_lad,
    }),
    ...mapState('modals', {
      isAvailabilityModalOpen: (state) => state.availability.opened,
    }),
    ...mapState('availability', {
      availabilityRanges: (state) => state.availability.ranges,
      itemsByCode: (state) => state.availabilityByCode,
    }),
    current() {
      return this.availabilityRanges.find((range) => range.current)
    },
    items() {
      return this.current && this.current.items.length
        ? this.current.items[0].availability
        : []
    },
  },
  beforeDestroy() {
    if (this.isAvailabilityModalOpen) {
      this.handleClose()
    }
  },
  methods: {
    handleReserve(item) {
      this.$emit('reserve', {
        uuid: this.experience.uuid,
        date: item.datetime.start,
      })

      this.handleClose()
    },
    async handleClose() {
      await this.$store.dispatch('modals/toggle', 'availability')
    },
    handleScrolled(value) {
      this.isScrolledToBottom = value
    },
  },
}
</script>

<style lang="scss">
.dialog--experience-availability {
  .el-dialog {
    width: 65%;
    max-width: 780px;
    min-width: 650px;
    margin-top: 9vh !important;

    .el-dialog__headerbtn {
      display: none;
    }

    &__footer {
      text-align: center;

      section {
        background-color: transparent;
      }
    }

    @media screen and (max-width: 900px) {
      width: 65%;
      max-width: inherit;
      min-width: 400px;

      .el-dialog__headerbtn {
        display: block;
        font-size: 1.8em;
        left: 20px;
        top: 20px;

        i {
          color: #c0c4cc;
        }
      }
    }

    @media screen and (max-width: 420px) {
      margin-top: 5px !important;
      height: calc(100% - 10px);

      .experience-wrapper--body {
        max-height: calc(100% - 2px);
      }
    }

    @media screen and (max-width: 400px) {
      width: 90%;
      min-width: 300px;

      .el-dialog__headerbtn {
        top: 30px;
      }

      &__header {
        padding: 10px 5px 10px 5px;
      }
    }

    @media screen and (max-width: 340px) {
      .el-dialog__headerbtn {
        font-size: 1.3em;
      }
    }
  }

  p {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
